
import React from 'react';
import { LucideIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

interface ActionCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  buttonText: string;
  buttonAction: () => void;
  backgroundColor: string;
}

export const ActionCard: React.FC<ActionCardProps> = ({
  icon: Icon,
  title,
  description,
  buttonText,
  buttonAction,
  backgroundColor,
}) => {
  return (
    <Card className={`${backgroundColor} border-none shadow-md flex flex-col`}>
      <CardContent className="text-center pt-4 pb-4 px-4 flex-grow flex flex-col justify-between">
        <div className="mb-3">
          <div className="flex justify-center mb-2">
            <Icon className="h-6 w-6 text-[#00123A]" />
          </div>
          <h3 className="text-lg font-semibold text-[#00123A] mb-2">{title}</h3>
          <p className="text-sm text-[#00123A]">
            {description}
          </p>
        </div>
        <div className="mt-auto">
          <Button 
            variant="secondary" 
            className="bg-white text-[#00123A] hover:bg-white/90 font-semibold px-4 py-2 h-auto text-sm"
            onClick={buttonAction}
          >
            {buttonText}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
